import { fromGrantKey } from "@p0security/integrations-gcloud-shared/assessment";
import { EMPTY_USAGE } from "@p0security/shared/assessment/reducers/grant";
import {
  AggregatedGraph,
  AggregatedNode,
} from "@p0security/shared/graph/aggregate";
import {
  AnyAggregates,
  AssessmentNodes,
} from "@p0security/shared/types/assessment/data/index";
import {
  Finding,
  FindingNode,
} from "@p0security/shared/types/assessment/finding";
import { MonitorPriority } from "@p0security/shared/types/assessment/monitor";
import { sortBy } from "lodash";
import { colors } from "styles/variables";

const syntheticNode = (node: FindingNode) => {
  let out: AggregatedNode<
    AssessmentNodes,
    keyof AssessmentNodes,
    AnyAggregates
  >;
  switch (node.type) {
    case "grant":
      {
        out = {
          ...node,
          aggregates: {
            privileges: {},
            risks: [],
            principals: [],
            usages: EMPTY_USAGE,
          },
          children: [],
          parents: [],
          // TODO: this is gcloud specific, make generic
          data: fromGrantKey(node.key),
        };
      }
      break;
    case "identity":
      out = {
        ...node,
        aggregates: {
          grants: [],
          privileges: {},
          risks: [],
        },
        children: [],
        parents: [],
        data: {},
      };
      break;
    default:
      return undefined;
  }
  return { ...out, children: [], parents: [] };
};

export const monitorFindingsToNodes = (
  findings: Finding[],
  aggregated: AggregatedGraph<AssessmentNodes, AnyAggregates>
) => {
  const byKey = Object.fromEntries(aggregated.nodes.map((n) => [n.key, n]));
  const out = sortBy(findings, (f) => f.node.key).map(
    (f) => byKey[f.node.key] ?? syntheticNode(f.node)
  );
  return { nodes: out };
};

export const priorityColor: Record<
  MonitorPriority,
  {
    color: string;
    text: string;
    tagColor: {
      bg: string;
      text: string;
    };
  }
> = {
  CRITICAL: {
    color: colors.themeColors.red,
    text: "#5c0011",
    tagColor: colors.tagColors.red,
  },
  HIGH: {
    color: colors.themeColors.lightOrange,
    text: "#614700",
    tagColor: colors.tagColors.orange,
  },
  MEDIUM: {
    color: colors.themeColors.yellow,
    text: "#ffffff",
    tagColor: colors.tagColors.yellow,
  },
  LOW: {
    color: colors.themeColors.darkBlue,
    text: "#595959",
    tagColor: colors.tagColors.grey,
  },
};
